import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal ,NgbDatepickerConfig} from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/Service/auth.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { FilesService } from '../../../../Pages/files/files-api.service';
import { UserService } from 'src/app/User/Service/user.service';
import { GlobalConstants } from 'src/app/utils/global-constants';
import { LoggingService } from 'src/app/Service/logging.service';

@Component({
    selector: 'app-sharelink',
    templateUrl: './sharelink.component.html',
    styleUrls: ['./sharelink.component.css'],
    standalone: false
})
export class ShareLinkComponent implements OnInit {
  secureLink;
  form: UntypedFormGroup;
  showEmail = false;
  bearertoken;
  @Input() fileid = '';
  @Input() otherIndividualsForm: any;
  dataRules = [];
  subscriptions = new Subscription();
  constructor(
    public fileDataService: FilesService,
    public http: HttpClient,
    private fb: UntypedFormBuilder,
    public notify: NotificationService,
    public activatedRoute: ActivatedRoute,
    public auth: AuthService,
    public modal: NgbModal,
    private config: NgbDatepickerConfig,
    public user: UserService,
    public logging: LoggingService,
  ) {
    const current = new Date();
    config.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate(),
    };
    config.outsideDays = 'hidden';
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  ngOnInit(): void {
    this.form = this.fb.group({
      id: [null, Validators.required],
      email: [this.otherIndividualsForm?.email, [Validators.pattern(GlobalConstants.emailPattern)]],
      AllowedAccessCount: ['1', Validators.required],
      NeverExpires: [true, Validators.required],
      secureLink: [null, Validators.required],
      message: [null],
      ExpiryDate: [null],
    });
    this.auth.getTokenSilently$().subscribe((token) => {
      this.bearertoken = token;
    });
    this.getFileShareLink();
  }
  copylink() {
    navigator.clipboard.writeText(this.secureLink);
    this.notify.showInfo('Link Copied');
  }
  getFileShareLink() {
    this.fileDataService.GetFileShareLink(this.fileid).subscribe(({ data }) => {
      if (data) {
        this.form.controls['id'].setValue(data.id);
        this.form.controls['secureLink'].setValue(data.link);
      }
    });
  }
  async sharelink() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      this.fileDataService
        .SecureFileShare(this.form.value)
        .subscribe(({ data }) => {
          if (data) {
            this.modal.dismissAll();
            this.notify.showSuccess('Link shared successfully');
          }
        });
    }
  }
  allowOnlyNumbers(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
